import type {
    LoaderFunctionArgs,
    ActionFunctionArgs,
} from '~/types/route-args';
import { data as routerData } from 'react-router';
import { getSession } from '~/modules/root/util/session.server';

export const RESET_AUTO_FILTERS_ACTION = '/actions/search/reset-auto-filters';

/**
 * Reset the search auto-filter in the session so all searches can be classified again.
 */
export const loader = async ({ request }: LoaderFunctionArgs) => {
    const session = await getSession(request);
    session.setSearchFilters(undefined);

    return routerData(null, {
        headers: await session.getHeaders({
            'Cache-Control': 'no-store',
        }),
    });
};

/**
 * Same as the loader so this endpoint can be used with GET or POST.
 */
export const action = async (args: ActionFunctionArgs) => {
    return loader(args);
};
